import type { AlertsAction } from './actions';
import { AlertActionNames } from './actionTypes';
import { type Draft, produce } from 'immer';
import type { Reducer } from 'redux';

import type { AlertItemProps } from '../../components';

export interface AlertsGroupState {
  alertsData: AlertItemProps[];
}

export const alertsInitialState: AlertsGroupState = {
  alertsData: [],
};

export const alertsReducer: Reducer<AlertsGroupState, AlertsAction> = produce(
  (draft: Draft<AlertsGroupState>, action: AlertsAction) => {
    switch (action.type) {
      case AlertActionNames.SHOW_ALERT_ACTION:
        draft.alertsData.push({
          alertType: action.alertType,
          message: action.message,
          alertConfig: action.alertConfig,
          id: action.id,
        });

        break;

      case AlertActionNames.REMOVE_ALERT_ACTION:
        const alertID = action.id;

        draft.alertsData = draft.alertsData.filter(
          (alert) => alert.id !== alertID
        );

        break;
    }
  },
  alertsInitialState
);
